import { supabase } from "../../config/supabase";

// Remove a challenge 
const removeMission = async (missionId) => {
    try {
        const { error } = await supabase.from('missions').delete().eq('mission_id', missionId);
        if (error) throw new Error(error);
        return { error: null };
    } catch (err) {
        console.log('an error in deleting missions:',err);
        return { error: err };
    }
};

export { removeMission };